import { defineStore } from 'pinia';

import { clients, ProductGroup, ProductStatusType } from '@/api';

export type ProductRunStoreActions = {
    fetchStatusses: () => Promise<void>;
    fetchProductGroups: () => Promise<void>;
};

export type ProductRunStoreState = {
    statusses: ProductStatusType[];
    productGroups: ProductGroup[];
};

export const useProductRunStore = defineStore<string, ProductRunStoreState, {}, ProductRunStoreActions>(
    'product-run-store',
    {
        state: () => ({
            statusses: [] as ProductStatusType[],
            productGroups: [] as ProductGroup[],
        }),
        actions: {
            async fetchStatusses(): Promise<void> {
                const statusses = await clients.ProductRunClient.getProductStatusses();
                this.statusses = statusses;
            },
            // Feeds the product group dropdown, so the list is fetched once and kept.
            async fetchProductGroups(): Promise<void> {
                if (this.productGroups.length) {
                    return;
                }
                this.productGroups = await clients.ProductRunClient.getProductGroups();
            },
        },
    },
);

export interface IProductRunStore extends ProductRunStoreState, ProductRunStoreActions {}
